import { Box, Typography } from "@mui/material";
import React from "react";
export function MainPage() {
  return (
    <Box>
      <Typography variant="h1">Hello welcome to my new website</Typography>
    </Box>
  );
}
